import { createFileRoute } from '@tanstack/react-router'
import { AuthContainer } from '@/components/auth/AuthContainer'

export const Route = createFileRoute('/_unauth/register')({
  component: RegisterPage,
})

function RegisterPage() {
  return (
    <AuthContainer initialState="signUp" redirectTo="/dashboard" />
  )
}
